import * as i0 from '@angular/core';
import { Component, Input, NgModule } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';

class Tag {
    constructor() {
        this._variant = 'positive';
        this.variantClasses = '';
        this.label = '';
        this.isBlurred = false;
        this.isStrikedThrough = false;
        this.style = {};
    }
    set variant(variantType) {
        this._variant = variantType;
        this.variantClasses = `feedback-text-${variantType} feedback-background-${variantType}-low-contrast`;
    }
}
Tag.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: Tag, deps: [], target: i0.ɵɵFactoryTarget.Component });
Tag.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.9", type: Tag, selector: "pv-tag", inputs: { variant: "variant", label: "label", isBlurred: "isBlurred", isStrikedThrough: "isStrikedThrough", style: "style" }, ngImport: i0, template: "<span\n  class=\"pv-offer-tag pt-1 pb-1 pl-2 pr-2 font-semibold text-xs uppercase\"\n  [ngClass]=\"this.variantClasses\"\n  [class.opacity-30]=\"this.isBlurred\"\n  [class.line-through]=\"this.isStrikedThrough\"\n  [style]=\"this.style\">\n  {{ this.label }}\n</span>\n", dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: Tag, decorators: [{
            type: Component,
            args: [{ selector: 'pv-tag', template: "<span\n  class=\"pv-offer-tag pt-1 pb-1 pl-2 pr-2 font-semibold text-xs uppercase\"\n  [ngClass]=\"this.variantClasses\"\n  [class.opacity-30]=\"this.isBlurred\"\n  [class.line-through]=\"this.isStrikedThrough\"\n  [style]=\"this.style\">\n  {{ this.label }}\n</span>\n" }]
        }], propDecorators: { variant: [{
                type: Input
            }], label: [{
                type: Input
            }], isBlurred: [{
                type: Input
            }], isStrikedThrough: [{
                type: Input
            }], style: [{
                type: Input
            }] } });

class PvTagModule {
}
PvTagModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: PvTagModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
PvTagModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.9", ngImport: i0, type: PvTagModule, declarations: [Tag], imports: [CommonModule], exports: [Tag] });
PvTagModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: PvTagModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: PvTagModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    exports: [Tag],
                    declarations: [Tag],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { PvTagModule, Tag };
